module.exports = __webpack_public_path__ + "static/bannerVideo-ebd19aefe87325995400972e2c7b8d16.mp4";